import { useState } from 'react';
import './IntroVideo.css';

/* الفيديو التعريفي: صورة غلاف عليها زر تشغيل، والضغط عليها يشغّل الفيديو بالصوت.
   يملأ الإطار الأب بالكامل، فالإطار هو اللي يحدد المقاس (aspect-ratio). */
const IntroVideo = ({ src, poster, label }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="intro-video">
      {playing ? (
        <video className="intro-video-player" src={src} poster={poster} controls autoPlay playsInline />
      ) : (
        <button type="button" className="intro-video-cover" onClick={() => setPlaying(true)} aria-label={label}>
          <img src={poster} alt="" />
          <span className="intro-video-play" aria-hidden="true"><i className="fas fa-play"></i></span>
        </button>
      )}
    </div>
  );
};

export default IntroVideo;
